export default {
  name: [
    {
      rule: 'minlengthequal',
      parameters: ['1'],
    },
    {
      rule: 'maxlengthequal',
      parameters: ['60'],
    },
  ],
  description: [
    {
      rule: 'notempty',
      parameters: [],
    },
    {
      rule: 'maxlengthequal',
      parameters: ['170'],
    },
    {
      rule: 'minlengthequal',
      parameters: ['1'],
    },
  ],
  media: [],
  owner: [],
  id: [],
  created: [],
  updated: [],
  deleted: [],
  version: [],
  mediaStatus: [
    {
      rule: 'oneof',
      parameters: ['MediaStatus'],
    },
  ],
  seriesId: [],
  approvedMedia: [],
}
